import React, { lazy } from 'react';
import { FadeIn, Section } from './Section';
import { SparklesIcon } from 'lucide-react';
const bonuses = [{
  num: '1',
  title: 'Construcción de Identidad',
  desc: 'Guía práctica para reprogramar cómo te ves, cómo hablás y cómo te movés en el mundo. Porque el afuera siempre refleja el adentro.',
  image: 'https://images.unsplash.com/photo-1531746020798-e6953c6e8e04?w=240&h=240&fit=crop&q=70&auto=format',
  alt: 'Mujer escribiendo en un diario personal'
}, {
  num: '2',
  title: 'Ideas Reales para Emprender',
  desc: 'Más de 30 ideas de negocios viables, adaptadas a mujeres latinoamericanas. Organizadas por habilidad, tiempo e inversión inicial.',
  image: 'https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?w=240&h=240&fit=crop&q=70&auto=format',
  alt: 'Cuaderno con ideas de negocio'
}, {
  num: '3',
  title: 'Errores que Debés Evitar',
  desc: 'Los errores más costosos al monetizar tu habilidad — y cómo evitarlos antes de que te cuesten meses, dinero o clientas equivocadas.',
  image: 'https://images.unsplash.com/photo-1554224155-6726b3ff858f?w=240&h=240&fit=crop&q=70&auto=format',
  alt: 'Análisis y planificación financiera'
}, {
  num: '4',
  title: 'Optimización de Recursos y Entorno',
  desc: 'Herramientas gratuitas, hábitos de gestión del tiempo y cómo construir un entorno que apoye tu crecimiento en lugar de sabotearlo.',
  image: 'https://images.unsplash.com/photo-1499951360447-b19be8fe80f5?w=240&h=240&fit=crop&q=70&auto=format',
  alt: 'Espacio de trabajo minimalista organizado'
}];
export function Bonuses() {
  return <Section bg="cream-dark" data-id="element-16">
      <FadeIn className="text-center mb-8 md:mb-16" data-id="element-17">
        <h2 className="text-xs md:text-sm font-bold tracking-[0.2em] uppercase text-plum/60 mb-3 md:mb-4" data-id="element-18">
          Incluidos Gratis
        </h2>
        <p className="font-serif text-3xl md:text-5xl text-plum mb-3 md:mb-4" data-id="element-19">
          5 Bonos Estratégicos
        </p>
        <p className="text-xs md:text-base text-plum/70 max-w-xl mx-auto" data-id="element-20">
          Sin costo extra · Incluidos en todas las opciones
        </p>
      </FadeIn>

      {/* Compact 2-column grid — even on mobile */}
      <div className="grid grid-cols-2 gap-3 md:gap-5 max-w-5xl mx-auto mb-4 md:mb-6" data-id="element-21">
        {bonuses.map((bonus, i) => <FadeIn key={i} delay={i * 0.08} className="bg-cream border border-plum/5 hover:border-plum/15 transition-colors duration-300 overflow-hidden rounded-sm flex flex-col" data-id="element-22">
            {/* Thumbnail image */}
            <div className="aspect-square w-full overflow-hidden bg-plum/5" data-id="element-23">
              <img src={bonus.image} alt={bonus.alt} width="240" height="240" loading="lazy" decoding="async" className="w-full h-full object-cover transition-transform duration-500 hover:scale-105" data-id="element-24" />
            </div>

            {/* Compact text body */}
            <div className="p-3 md:p-5 flex-grow flex flex-col" data-id="element-25">
              <span className="text-[9px] md:text-[10px] font-bold tracking-[0.2em] uppercase text-gold mb-1.5 md:mb-2 block" data-id="element-26">
                Bono {bonus.num}
              </span>
              <h3 className="font-serif text-sm md:text-lg text-plum mb-1.5 md:mb-2 leading-tight" data-id="element-27">
                {bonus.title}
              </h3>
              <p className="text-[11px] md:text-sm text-plum/65 leading-snug line-clamp-3 md:line-clamp-none" data-id="element-28">
                {bonus.desc}
              </p>
            </div>
          </FadeIn>)}
      </div>

      {/* Bono Extra — premium block */}
      <FadeIn delay={0.4} className="max-w-5xl mx-auto" data-id="element-29">
        <div className="bg-plum text-cream p-4 md:p-10 border border-plum-light relative overflow-hidden rounded-sm flex flex-col md:flex-row gap-4 md:gap-8 items-center" data-id="element-30">
          {/* Library image */}
          <div className="w-24 h-24 md:w-40 md:h-40 flex-shrink-0 overflow-hidden rounded-sm border border-gold/20" data-id="element-31">
            <img src="https://images.unsplash.com/photo-1481627834876-b7833e8f5570?w=320&h=320&fit=crop&q=70&auto=format" alt="Biblioteca digital con libros de mentalidad y desarrollo personal" width="320" height="320" loading="lazy" decoding="async" className="w-full h-full object-cover" data-id="element-32" />
          </div>

          <SparklesIcon className="hidden md:block absolute top-6 right-6 text-gold opacity-15" size={100} data-id="element-33" />

          <div className="relative z-10 text-center md:text-left flex-1" data-id="element-34">
            <span className="inline-flex items-center gap-1.5 bg-gold text-white text-[9px] md:text-xs font-bold tracking-[0.2em] uppercase px-2 py-1 mb-3 md:mb-4" data-id="element-35">
              <SparklesIcon size={10} data-id="element-36" /> Bono Extra
            </span>
            <h3 className="font-serif text-xl md:text-3xl mb-2 md:mb-3 leading-tight" data-id="element-37">
              Biblioteca Digital + 25 Libros
            </h3>
            <p className="text-xs md:text-base text-cream/80 leading-relaxed" data-id="element-38">
              Biblioteca curada con 25 libros sobre mentalidad, dinero,
              emprendimiento y desarrollo personal. Todo lo que deberías haber
              leído antes — en un solo lugar.
            </p>
          </div>
        </div>
      </FadeIn>
    </Section>;
}